export const capitalizeFirstLetter = (string) => {
    if (string === null || string === undefined) {
      return string;
    }
  
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}